
import { useState } from 'react';
import { Link } from 'react-router-dom';

interface NavigationProps {
  isScrolled: boolean;
}

export default function Navigation({ isScrolled }: NavigationProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const navLinks = [
    { href: '#leistungen', label: 'Leistungen' },
    { href: '#ueber-uns', label: 'Über uns' },
    { href: '#kontakt', label: 'Kontakt' },
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img
                src="https://public.readdy.ai/ai/img_res/cd59830a-a811-4b8c-95fb-12d94d035ec5.png"
                alt="Elektro Tomasevic KG Logo"
                className="h-10 sm:h-12 w-auto"
              />
            </Link>

            {/* Desktop Links */}
            <div className="hidden md:flex items-center space-x-8">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className={`text-base font-medium transition-colors whitespace-nowrap ${
                    isScrolled ? 'text-[#1A2B4A] hover:text-[#F4B942]' : 'text-white hover:text-[#F4B942]'
                  }`}
                >
                  {link.label}
                </a>
              ))}
            </div>

            <div className="flex items-center gap-3">
              <a
                href="#kontakt"
                className="hidden sm:inline-flex bg-[#F4B942] text-[#1A2B4A] px-5 py-2.5 rounded-full font-semibold hover:bg-[#e5a832] transition-all duration-300 hover:shadow-lg whitespace-nowrap text-sm"
              >
                Kostenlose Beratung
              </a>

              {/* Hamburger Button */}
              <button
                onClick={() => setMobileOpen(true)}
                className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
                  isScrolled ? 'text-[#1A2B4A]' : 'text-white'
                }`}
                aria-label="Menü öffnen"
              >
                <i className="ri-menu-line text-2xl"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {mobileOpen && (
        <div className="fixed inset-0 z-[100] md:hidden">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setMobileOpen(false)}
          ></div>
          <div className="absolute top-0 right-0 h-full w-72 bg-white shadow-2xl flex flex-col">
            <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">
              <img
                src="https://public.readdy.ai/ai/img_res/cd59830a-a811-4b8c-95fb-12d94d035ec5.png"
                alt="Elektro Tomasevic KG"
                className="h-10 w-auto"
              />
              <button
                onClick={() => setMobileOpen(false)}
                className="w-10 h-10 flex items-center justify-center text-[#1A2B4A] cursor-pointer"
                aria-label="Menü schließen"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <nav className="flex flex-col px-6 py-6 gap-1 flex-1">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMobileOpen(false)}
                  className="text-[#1A2B4A] font-medium text-lg py-3 border-b border-gray-100 hover:text-[#F4B942] transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </nav>

            <div className="px-6 pb-8">
              <a
                href="#kontakt"
                onClick={() => setMobileOpen(false)}
                className="block w-full text-center bg-[#F4B942] text-[#1A2B4A] px-6 py-4 rounded-full font-bold text-base hover:bg-[#e5a832] transition-colors whitespace-nowrap"
              >
                Kostenlose Beratung
              </a>
              <a
                href="tel:+436991223301"
                className="flex items-center justify-center gap-2 mt-3 text-[#1A2B4A] font-medium text-sm py-3"
              >
                <i className="ri-phone-fill text-[#F4B942]"></i>
                +43 699 122 333 01
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
